"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStorage = void 0;
const react_1 = require("react");
const parseStorageItem_1 = require("../fragments/parseStorageItem");
const StoragePrefixProvider_1 = require("../StoragePrefix/StoragePrefixProvider");
const STORAGE = window.localStorage;
const initiateStorage = (key, initialValue) => {
    const value = (0, parseStorageItem_1.parseStorageItem)(key);
    if (value === null) {
        STORAGE.setItem(key, JSON.stringify(initialValue));
        return initialValue;
    }
    return value;
};
const useStorage = (key, initialValue) => {
    const prefix = (0, StoragePrefixProvider_1.useStoragePrefix)();
    const [value, setValue] = (0, react_1.useState)(initiateStorage(prefix + key, initialValue));
    const setStorage = (0, react_1.useCallback)((value) => {
        STORAGE.setItem(prefix + key, JSON.stringify(value));
        setValue(value);
    }, [prefix, key]);
    return [value, setStorage];
};
exports.useStorage = useStorage;
